export default __webpack_public_path__ + "static/media/zucchero4.4df36eee.webp";